import { Col, Row } from '@guestyci/foundation/esm/Layout';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';

import useMediaQuery from '@guestyci/foundation/useMediaQuery';
import GuestyForHostsLogo from 'resources/NAV.svg';
import MarketingContainer from 'app/components/MarketingContainer';

const useStyles = createStyles((theme) => ({
  app: {
    background: theme.palette.background.white,
    minHeight: '100vh',
  },
  leftSideContainer: {
    background: '#FAFAFA',
  },
  fullHeightContainer: {
    flex: 1,
  },
  appLogoContainer: {
    paddingTop: '5vh',
    paddingLeft: '4vw',
    marginBottom: '7vh',
    '& img': {
      width: '127.71px',
    },
  },
  appLogo: {
    animation: '$spin infinite 10s linear',
    pointerEvents: 'none',
    height: 100,
    width: 100,
    margin: 40,
  },
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
}));

const mediaQuery = {
  maxWidth: 'md',
};

const contentBreakpoints = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 8,
};

const RegistrationLayout = ({ children }) => {
  const classes = useStyles();

  const isMobile = useMediaQuery(mediaQuery);

  return (
    <Col fullWidth className={classes.app} id="main-app">
      <Row className={classes.fullHeightContainer}>
        <Col breakpoints={contentBreakpoints} className={classes.leftSideContainer}>
          <Row className={classes.appLogoContainer}>
            <img id="app-logo" src={GuestyForHostsLogo} alt="Guesty For Hosts Logo" />
          </Row>
          <Row justify="center" className={classes.fullHeightContainer}>
            <Col className="p-3" span={12}>
              {children}
            </Col>
          </Row>
        </Col>
        {!isMobile && <MarketingContainer />}
      </Row>
    </Col>
  );
};

export default RegistrationLayout;
